module.exports = __webpack_public_path__ + "static/img/11.3450d1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/features_admin/11.png
// module id = VWIW
// module chunks = 0